/**
 * Ensures `next` query string gets passed along to the login page.
 */
export const getLoginHref = (href: string) => {
  const currentUrl = new URL(window.location.href)
  const newUrl = new URL(href, window.location.origin)

  if (newUrl.searchParams.has('next')) {
    return newUrl.toString()
  }

  const next = currentUrl.searchParams.get('next')
  if (next) {
    newUrl.searchParams.set('next', next)
  }

  return newUrl.toString()
}
